import { HttpError } from '@rover/rsdk/src/errors';
import { Http404Error, Http410Error } from '@rover/utilities/HttpError';
import { Upstream, UpstreamRedirect } from '@rover/utilities/upstream';

export const handleSeoLocationQueryError = (error: unknown): never => {
  if (error instanceof HttpError) {
    // Use statusCode property directly - this is the correct way to get the status from HttpError
    const status = error.statusCode;
    // Cast status to string to handle potential type mismatches between number and string
    const statusString = String(status);
    switch (statusString) {
      case '404':
        throw new Http404Error();
      case '410':
        throw new Http410Error();
      case '400':
        throw new UpstreamRedirect(Upstream.DJANGO);
      default:
        break;
    }
  }
  throw error;
};
